import { COUNTRY_CALLING_CODES_BY_LENGTH } from './country-calling-codes.js';
/**
 * Normalise un numéro de téléphone brut vers le format +{indicatif}{numéro_local}.
 * Ajoute +33 par défaut si aucun indicatif n'est détecté.
 */
export function normalizePhoneNumber(raw) {
    if (raw === null || raw === undefined)
        return null;
    const cleaned = raw.replaceAll(/[\s\-.()/]/g, '');
    if (!cleaned)
        return null;
    if (cleaned.startsWith('+')) {
        const country = COUNTRY_CALLING_CODES_BY_LENGTH.find((c) => cleaned.startsWith(c.callingCode));
        if (country) {
            const nsn = cleaned.slice(country.callingCode.length).replace(/^0+/, '');
            return `${country.callingCode}${nsn}`;
        }
        return cleaned;
    }
    if (cleaned.startsWith('00')) {
        const withPlus = `+${cleaned.slice(2)}`;
        const country = COUNTRY_CALLING_CODES_BY_LENGTH.find((c) => withPlus.startsWith(c.callingCode));
        if (country) {
            const nsn = withPlus.slice(country.callingCode.length).replace(/^0+/, '');
            return `${country.callingCode}${nsn}`;
        }
    }
    const withPlus = `+${cleaned}`;
    const country = COUNTRY_CALLING_CODES_BY_LENGTH.find((c) => withPlus.startsWith(c.callingCode));
    if (country) {
        const nsn = withPlus.slice(country.callingCode.length).replace(/^0+/, '');
        return `${country.callingCode}${nsn}`;
    }
    const nsn = cleaned.replace(/^0+/, '');
    return `+33${nsn}`;
}
